import { render } from "./SettingsTop.vue?vue&type=template&id=3c617b70&scoped=true"
import script from "./SettingsTop.vue?vue&type=script&lang=js"
export * from "./SettingsTop.vue?vue&type=script&lang=js"

import "./SettingsTop.vue?vue&type=style&index=0&id=3c617b70&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-3c617b70"

export default script